/**
 * The natural-language form of a request: what a person hands to a coding agent
 * instead of the cURL line. One owner, so the prompt a reader can see ("Show
 * prompt") and the prompt an agent receives through a deeplink cannot say two
 * different things.
 *
 * The prompt never carries an API key. One of the three deeplink targets is a
 * remote https URL (Cursor's link service), so a key placed in this string
 * would be handed to a third party the moment someone opened it there. The
 * agent gets the key the way every other agent does: from SKILL.md.
 */

import { AGENT_ENDPOINTS } from './agentContent';

export interface SkuPromptInput {
  /** The SKU slug, e.g. `instagram.profile`. */
  sku: string;
  /** Human name of what the SKU returns, e.g. "Instagram Profile". */
  title?: string;
}

/** "Use AnyAPI's instagram.profile endpoint to get Instagram Profile data." */
export const buildSkuPrompt = ({ sku, title }: SkuPromptInput): string => {
  const goal = title?.trim();
  const opening = goal
    ? `Use AnyAPI's ${sku} endpoint to get ${goal} data.`
    : `Use AnyAPI's ${sku} endpoint.`;
  return `${opening} Docs: ${AGENT_ENDPOINTS.skill}`;
};
